import React from 'react';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Tooltip } from 'antd';

export const BaseTooltip = ({
    placement = 'bottom',
    type,
    objectName = '',
    title,
    toLowerCase = true,
    children,
    ...props
}) => {
    const translate = useTranslate();
    if (toLowerCase) {
        objectName = objectName.toLowerCase();
    }
    const titleMapping = {
        edit: `${translate.formatMessage(commonMessage.edit)} ${objectName}`,
        delete: `${translate.formatMessage(commonMessage.delete)} ${objectName}`,
    };

    title = titleMapping[type] || title;
    return (
        <Tooltip placement={placement} title={title} {...props}>
            {children}
        </Tooltip>
    );
};